import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { icon: '🍗', name: 'Chicken', slug: 'chicken' },
  { icon: '🥩', name: 'Grill', slug: 'grill' },
  { icon: '🐟', name: 'Fish', slug: 'fish' },
  { icon: '🍕', name: 'Pizza', slug: 'pizza' },
  { icon: '🍔', name: 'Burger', slug: 'burgers' },
  { icon: '🥤', name: 'Drinks', slug: 'drinks' },
  { icon: '☕', name: 'Coffee', slug: 'coffee' },
  { icon: '🍰', name: 'Desserts', slug: 'desserts' },
  { icon: '🥚', name: 'Breakfast', slug: 'breakfast' },
  { icon: '🌯', name: 'Rolex', slug: 'rolex' },
];

const CategoryStrip = () => (
  <section className="category-strip">
    <div className="container">
      <div className="text-center mb-4">
        <span className="section-subtitle">What We Serve</span>
        <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', fontWeight: 600 }}>
          Explore Our Categories
        </h2>
      </div>
      <div className="category-strip-scroll">
        {categories.map((cat, i) => (
          <Link key={i} to={`/menu?category=${cat.slug}`} className="category-tile" data-track="category_click">
            <span className="cat-icon">{cat.icon}</span>
            <span className="cat-name">{cat.name}</span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default CategoryStrip;
